import i18n from '@/i18n'
import { gpsService } from '@/services/gps.service'
import { mapActions } from 'vuex'
import { SnackbarStyle, REGEX, EventHub } from '@/constants/constants'
import moment from 'moment'
import { DialogGPS } from "@/tools/dialog"
import GpsDialogFirstTabComponent from './tabs/first/GpsDialogFirstTabComponent.vue'
import GpsDialogSecondTabComponent from './tabs/second/GpsDialogSecondTabComponent.vue'
import Vue from 'vue'

export default {
    name: 'GpsDialogComponent',
    components: {
        GpsDialogFirstTabComponent,
        GpsDialogSecondTabComponent
    },
    props: {
        // v-model injects the object to be edited into props.value
        model: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // tab seleccionada
        tab: null,
        // modelos de los tabs
        firstTabModel: {
            key: 'gpsDialogFirstTab',
            tab: i18n.t('data'),
            tooltip: i18n.t('gps.editDialog.tabs.first'),
            icon: 'mdi-form-textbox',
            content: {
                _uid: 'Ge5hC1ZXTa',
                component: 'GpsDialogFirstTabComponent',
                headline: 'GpsDialogFirstTabComponent'
            },
            model: {
                unitId: null,
                stateId: null,
                brandId: null,
                modelId: null,
                line1: null,
                line1Number: null,
                line2: null,
                line2Number: null,
                update: false
            },
            validForm: false
        },
        secondTabModel: {
            key: 'gpsDialogSecondTab',
            tab: i18n.t('details'),
            tooltip: i18n.t('gps.editDialog.tabs.second'),
            icon: 'mdi-form-textarea',
            content: {
                _uid: 'd52jvAjbyB',
                component: 'GpsDialogSecondTabComponent',
                headline: 'GpsDialogSecondTabComponent'
            },
            model: {
                firmware: null,
                serieNumber: null,
                buyDate: null,
                description: null,
                communicationModuleId: null,
                update: false
            },
            validForm: false
        },
        items: [],
        // reglas de validación
        validationRules: {
            required: (value) => !!value || `${i18n.t('required')}`,
            max: (value, maxValue) => !value || value.length <= maxValue || `${i18n.t('maxLengthCharacters', {max: maxValue})}`,
            distinctLines: (value, otherValue) => !value || !otherValue || (value && otherValue && value !== otherValue) || `${i18n.t('gps.equalLines')}`,
            hexadecimal: (value) => (value && REGEX.hexadecimal.test(value)) || `${i18n.t('gps.invalidIdentificator')}`,
        },
        // para mostrar / ocultar el dialog de edición
        showEditDialog: false,
        // título del dialog
        editDialogTitle: i18n.t('gps.editDialog.titleNew'),
        // flag para resetear validaciones en los formularios
        resetForms: false
    }),
    computed: {
        /**
         * Convierte la fecha de compra a timestamp
         */
        buyDateTimestamp() {
            return this.secondTabModel.model.buyDate ? moment(this.secondTabModel.model.buyDate, 'YYYY-MM-DD').unix() : null
        }
    },
    created() {
        this.items.push(this.firstTabModel, this.secondTabModel)
    },
    mounted() {
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            this.firstTabModel.model.unitId = null
            this.firstTabModel.model.stateId = null
            this.firstTabModel.model.brandId = null
            this.firstTabModel.model.modelId = null
            this.firstTabModel.model.line1 = null
            this.firstTabModel.model.line2 = null
            this.firstTabModel.model.line1Number = null
            this.firstTabModel.model.line2Number = null

            this.secondTabModel.model.firmware = null
            this.secondTabModel.model.serieNumber = null
            this.secondTabModel.model.buyDate = null
            this.secondTabModel.model.description = null
            this.secondTabModel.model.communicationModuleId = null

            this.firstTabModel.model.update = false
            this.secondTabModel.model.update = false

            // para limpiar las validaciones en los formularios
            this.resetForms = true
            const that = this
            Vue.nextTick(function() {
                that.resetForms = false
            })
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(DialogGPS)
            this.resetFields()
        },
        /**
         * Guardar
         */
        save() {
            const gpsDto = this.getGpsDto(this.model.update)
            if (this.model.update) {
                gpsService.update(gpsDto).then(() => {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('gps.successUpdateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    this.resetFields()
                    this.$emit('commitGps')
                    this.cancel()
                    this.$eventBus.$emit(EventHub.COMMIT_GPS, gpsDto)
                })
            } else {
                // CREATE
                gpsService.create(gpsDto).then(insertedId => {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('gps.successCreateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    this.resetFields()
                    this.$emit('commitGps')
                    this.cancel()
                    gpsDto._id = insertedId
                    this.$eventBus.$emit(EventHub.COMMIT_GPS, gpsDto)
                })
            }
        },
        /**
         * Genera el dto para creación o actualización
         * @param {*} update
         */
        getGpsDto(update = false) {
            const dto = {
                unitId: this.firstTabModel.model.unitId,
                brandId: this.firstTabModel.model.brandId,
                modelId: this.firstTabModel.model.modelId,
                buyDate: this.buyDateTimestamp,
                firmware: this.secondTabModel.model.firmware,
                serieNumber: this.secondTabModel.model.serieNumber,
                stateId: this.firstTabModel.model.stateId,
                communicationModuleId: this.secondTabModel.model.communicationModuleId ?  this.secondTabModel.model.communicationModuleId : null,
                line1: this.firstTabModel.model.line1 ? this.firstTabModel.model.line1 : null,
                line2: this.firstTabModel.model.line2 ? this.firstTabModel.model.line2 : null,
                
                description: this.secondTabModel.model.description
            }
            if (update) {
                dto._id = this.model._id
            }
            return dto
        }
    },
    watch: {
        model: {
            deep: true,
            immediate: true,
            handler: function (newModel) {
                if (newModel) {
                    this.firstTabModel.model.unitId = newModel.unitId
                    this.firstTabModel.model.stateId = newModel.stateId
                    this.firstTabModel.model.brandId = newModel.brandId
                    this.firstTabModel.model.modelId = newModel.modelId
                    this.firstTabModel.model.line1 = newModel.line1
                    this.firstTabModel.model.line2 = newModel.line2
                    this.firstTabModel.model.line1Number = newModel.line1Number
                    this.firstTabModel.model.line2Number = newModel.line2Number
                    this.secondTabModel.model.firmware = newModel.firmware
                    this.secondTabModel.model.serieNumber = newModel.serieNumber
                    this.secondTabModel.model.buyDate = newModel.buyDate
                    this.secondTabModel.model.description = newModel.description
                    this.secondTabModel.model.communicationModuleId = newModel.communicationModuleId 
                    this.firstTabModel.model.update = newModel.update
                    this.secondTabModel.model.update = newModel.update
                }
            }
        }
    }
}
